<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <AccounBalances />
  </div>
</template>
  
  <script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import AccounBalances from "../../components/GestionEmpleados/Views/Employee/AccounBalances.vue";
export default {
  components: { LandingToolbar, AccounBalances },
};
</script>
  
  